// Vendor imports
const _ = require('lodash')
const qs = require('qs')

const safeWindowNames = ['_parent', '_self', '_top']

function openWindow(url, windowName, windowFeatures) {
  // Prevent "Reverse Tabnabbing" attacks
  // https://www.owasp.org/index.php/Reverse_Tabnabbing
  // https://github.com/danielstjules/blankshield#solutions
  if (safeWindowNames.includes(windowName)) {
    return window.open(url, windowName, windowFeatures)
  }
  return openWindowWithOpenerHack(url, windowName, windowFeatures)
}

function openWindowWithIframeHack(url, windowName, windowFeatures) {
  // Stringify arguments
  const openArgs = [url, windowName, windowFeatures]
  .map(arg => _.isString(arg) ? `"${arg}"` : 'undefined')
  .join(', ')
  // Create an ephemeral hidden IFRAME
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  document.body.appendChild(iframe)
  const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
  // Create a SCRIPT to evaluate inside the IFRAME
  const script = iframeDoc.createElement('script')
  script.type = 'text/javascript'
  script.text = `
    window.parent = null;
    window.top = null;
    window.frameElement = null;
    var child = window.open(${openArgs});
    if (child) { child.opener = null; }
  `
  iframeDoc.body.appendChild(script)
  const { child } = iframe.contentWindow
  document.body.removeChild(iframe)
  return child
}

function openWindowWithOpenerHack(url, windowName, windowFeatures) {
  const child = window.open(url, windowName, windowFeatures)
  try {
    child.opener = null
  } catch (e) {
    // Do nothing; this happens normally in some browsers
  }
  return child
}

function openWindowWithReferralRedirect(url, windowName, windowFeatures) {
  // Ensure that a referrer is set by bouncing off a redirect endpoint
  const redirectUrl = '/referral/redirect?' + qs.stringify({
    source: window.location.pathname + window.location.search,
    destination: url
  })
  return openWindowWithOpenerHack(redirectUrl, windowName, windowFeatures)
}

function centeredWindowFeatures(width, height) {
  // Handle multi-screen position
  const multiScreenLeft =
    _.get(window, 'screenLeft',
      _.get(screen, 'left'))
  const multiScreenTop =
    _.get(window, 'screenTop',
      _.get(screen, 'top'))

  const left = (windowWidth() / 2) - (width / 2) + multiScreenLeft
  const top = (windowHeight() / 2) - (height / 2) + multiScreenTop

  return [
    'scrollbars=yes', 'resizable=yes',
    `width=${width}`, `height=${height}`,
    `left=${left}`, `top=${top}`
  ].join(',')
}

function windowWidth() {
  return (
    _.get(window, 'innerHeight') ||
    _.get(document, 'documentElement.clientHeight') ||
    _.get(screen, 'height')
  )
}

function windowHeight() {
  return (
    _.get(window, 'innerHeight') ||
    _.get(document, 'documentElement.clientHeight') ||
    _.get(screen, 'height')
  )
}

function getScrollParent(node) {
  if (!node) {
    return null
  }
  const isElement = node instanceof HTMLElement
  const overflowY = isElement && window.getComputedStyle(node).overflowY
  const isScrollable = overflowY !== 'visible' && overflowY !== 'hidden'
  if (isScrollable && node.scrollHeight >= node.clientHeight) {
    return node
  }
  return getScrollParent(node.parentNode) || document.body
}

module.exports = {
  // Global helpers
  getScrollParent,
  // Opener helpers
  openWindow,
  openWindowWithIframeHack,
  openWindowWithOpenerHack,
  openWindowWithReferralRedirect,
  // Feature helpers
  centeredWindowFeatures
}
